import { createContext } from "react";

export const SendingContext = createContext<{
  isSending: boolean;
  setSending: () => void;
  clearSending: () => void;
}>({ isSending: false, setSending: () => {}, clearSending: () => {} });
